export const DIAMOND_HALF = 3
export const DIAMOND_HALF_ACTIVE = 8
export const DEFAULT_STROKE_WIDTH = 2
export const DEFAULT_STROKE_COLOR = "#bbb"
export const PROGRESS_STROKE_WIDTH = 8
export const PRIMARY_STROKE_WIDTH = 4.5
export const PRIMARY_STROKE_COLOR = "#bbb"
export const PRIMARY_PROGRESS_STROKE_WIDTH = 8
export const LINE_LENGTH = 40
export const CURVE_WIDTH = 30
export const CURVE_HORIZONTAL_SPAN = (CURVE_WIDTH * 3) / 4
export const CURVE_CONTROL_FRACTION = 1
export const MIN_SUBTREE_HEIGHT = 10
export const MIN_LINE_LENGTH = 3
export const PIXELS_PER_LINE = 0.2

export function getFutureLevelDashArray(futureLevel: number): string | undefined {
  return undefined
  if (futureLevel === 1) return "6 1"
  if (futureLevel === 2) return "4 2"
  if (futureLevel === 3) return "4 2"
  if (futureLevel === 4) return "4 8"
  return undefined
}
